// dependancies
import React from "react";
import PropTypes from "prop-types";

// styles
import InputStyled from "./Input.styled";

const Input = props => {
    const { id, type, name, change, keyup, focus, blur, value, required, error, disabled, autoComplete, icon, symbol, maxLength, min } = props;
    return (
        <InputStyled>
            {/* {used to add an icon to an input field pass icon as a prop to display } */}
            {icon && <div className="symbol">{symbol}</div>}
            <input
                autoComplete={autoComplete || "off"}
                id={id}
                type={type}
                name={name}
                onChange={change}
                onKeyUp={keyup}
                onFocus={focus}
                onBlur={blur}
                required={required}
                error={error}
                disabled={disabled}
                value={value}
                className={icon && "input__with__symbol"}
                maxLength={maxLength}
                min={min}
            />
        </InputStyled>
    );
};

// props validation
Input.propTypes = {
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf(["text", "number", "tel", "password", "email", "date"]).isRequired,
    name: PropTypes.string.isRequired,
    change: PropTypes.func,
    keyup: PropTypes.func,
    focus: PropTypes.func,
    blur: PropTypes.func,
    value: PropTypes.string,
    required: PropTypes.bool,
    error: PropTypes.bool,
    disabled: PropTypes.bool,
    autoComplete: PropTypes.string
};

export default Input;
